import { jsx as l } from "react/jsx-runtime";
import { useState as p, useEffect as f } from "react";
import { withManagedProps as d } from "@made-people/managed-props";
import { z as t } from "zod";
import { withZod as c } from "@made-people/react-prop-guard";
import { badgeBlueprint as u } from "./index-blueprint.es.js";
import { useTranslate as g } from "@made-people/grease-translations";
import b from "clsx";
import "@made-people/blueprint";
const h = t.object({
  variants: t.custom().optional(),
  label: t.string().optional(),
  className: t.string().optional(),
  rotate: t.union([t.boolean(), t.number(), t.literal("randomize")]).optional()
}), N = d(
  "Badge",
  c(
    {
      schema: h,
      defaultProps: {
        rotate: !1
      }
    },
    ({ variants: a, label: e, rotate: o, className: s }) => {
      const m = u.styles(a), i = g(), [r, n] = p(
        typeof o == "number" ? o : "randomize"
      );
      return f(() => {
        r === "randomize" && n(Math.random() * 12 - 6);
      }, [o]), /* @__PURE__ */ l(
        "div",
        {
          className: b(m.wrapper, s),
          style: o !== !1 ? { transform: `rotate(${r}deg)` } : void 0,
          children: e && i(e)
        }
      );
    }
  )
);
export {
  N as Badge,
  h as badgeSchema
};
//# sourceMappingURL=index.es.js.map
